export default __webpack_public_path__ + "static/media/pozaprf.fcab12b0.jpg";